import Phaser from 'phaser';
import { GameState } from '@/engine/GameState';
import { SCENE_KEYS } from '@/engine/nav';

/**
 * Primera escena en arrancar. Inicializa el GameState (carga el save desde
 * IndexedDB/localStorage) antes de dejar pasar al TitleScene. No dibuja
 * nada de contenido: es infraestructura pura.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super(SCENE_KEYS.BOOT);
  }

  create(): void {
    this.mostrarCargando();
    void this.arrancar();
  }

  private mostrarCargando(): void {
    const { width, height } = this.scale;
    this.add
      .text(width / 2, height / 2, 'Cargando…', {
        fontFamily: 'system-ui, sans-serif',
        fontSize: '28px',
        color: '#ffffff',
      })
      .setOrigin(0.5);
  }

  private async arrancar(): Promise<void> {
    if (!GameState.isReady()) {
      await GameState.init();
    }
    this.scene.start(SCENE_KEYS.TITLE);
  }
}
